
/*----- CREATE SELECTORS ------*/

import { ActionStatus } from "../../common/constants/action-status";
import { StoreState } from "../../store/store.interface";


export const getSchoolAddresses = (state: StoreState) => 
state.instructorSampleState.getSchoolAddress.data;

export const isLoadingSchoolAddress = (state: StoreState) => 
state.instructorSampleState.getSchoolAddress.status === ActionStatus.loading;

export const isSuccessSchoolAddress = (state: StoreState) => 
state.instructorSampleState.getSchoolAddress.status === ActionStatus.succeeded;

export const isFailedSchoolAddress = (state: StoreState) => 
state.instructorSampleState.getSchoolAddress.status === ActionStatus.failed;

export const getSchoolAddressError = (state: StoreState) => state.instructorSampleState.getSchoolAddress.error;

export const getSampleData = (state: StoreState) =>
    state.instructorSampleState.getInstructorData.data;

export const isFailedSampleData = (state: StoreState) => 
state.instructorSampleState.getInstructorData.status === ActionStatus.failed;

export const getSampleDataError = (state: StoreState) => state.instructorSampleState.getInstructorData.error;

export const getSampleOrderProductInfo = (state: StoreState) =>
state.instructorSampleState.getSampleOrderProductInfo.data;

export const getInstructorSampleOrderStatus = (state: StoreState) =>
  state.instructorSampleState.getInstructorSampleOrder.status;

export const getInstructorSampleOrderData = (state: StoreState) =>
  state.instructorSampleState.getInstructorSampleOrder?.data;

export const getInstructorSampleOrderOrderId = (state: StoreState) =>
  state.instructorSampleState.getInstructorSampleOrder?.data?.orderId;

export const getInstructorSampleOrderError = (state: StoreState) =>
  state.instructorSampleState.getInstructorSampleOrder.error;
